import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Is de demo echt gratis?",
    a: "Ja. De demo is vrijblijvend. U kunt eerst zien hoe een AI-chatbot voor uw bedrijf kan werken voordat u beslist om verder te gaan.",
  },
  {
    q: "Moet ik al weten wat de chatbot precies moet doen?",
    a: "Nee. U hoeft enkel uw gegevens en website achter te laten. Wij bekijken mee welke vragen en flows logisch zijn voor uw bedrijf.",
  },
  {
    q: "Werkt dit op mijn bestaande website?",
    a: "In de meeste gevallen wel. De chatbot kan normaal als extra chatknop op een bestaande website geplaatst worden.",
  },
  {
    q: "Geeft de chatbot automatisch antwoorden over mijn bedrijf?",
    a: "De chatbot wordt afgestemd op uw aanbod, veelgestelde vragen, tone of voice en gewenste aanvraagflow. Zo blijft de communicatie relevant voor uw bedrijf.",
  },
  {
    q: "Kan de chatbot aanvragen doorsturen?",
    a: "Ja. De chatbot kan gegevens verzamelen zoals naam, e-mail, telefoonnummer, type aanvraag en extra toelichting. Die aanvraag kan daarna doorgestuurd worden.",
  },
  {
    q: "Vervangt dit mijn contactformulier?",
    a: "Nee, dat hoeft niet. De chatbot kan naast uw bestaande formulier werken en bezoekers helpen die eerst nog vragen hebben.",
  },
  {
    q: "Waarom staan er geen prijzen op de website?",
    a: "Omdat de juiste oplossing afhangt van wat de chatbot moet doen, hoeveel informatie hij nodig heeft en hoe uitgebreid de aanvraagflow wordt. Daarom bekijken we eerst uw situatie via de demo.",
  },
  {
    q: "Wat als ik na de demo niet verder wil?",
    a: "Geen probleem. De demo is vrijblijvend. U beslist pas daarna of u de chatbot volledig wilt laten bouwen en installeren.",
  },
];

export const FAQ = () => {
  return (
    <section id="faq" className="relative py-16 md:py-20 scroll-mt-24">
      <div className="max-w-3xl mx-auto px-5 md:px-8">
        <div className="text-center">
          <span className="text-[11px] uppercase tracking-[0.22em] font-mono-display text-[#00FFB7]">
            FAQ
          </span>
          <h2 className="mt-4 font-display font-semibold text-white text-3xl md:text-[42px] tracking-tight leading-[1.1]">
            Veelgestelde <span className="text-gradient-neon">vragen</span>
          </h2>
          <p className="mt-4 text-[#A7A7A7] text-base md:text-[17px] leading-relaxed">
            Alles wat u moet weten voordat u een gratis demo aanvraagt.
          </p>
        </div>

        <div className="mt-10 glass-strong rounded-3xl p-2 md:p-3">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-white/5 last:border-b-0 px-4"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left text-white text-[15px] md:text-base font-medium py-5 hover:no-underline hover:text-[#00EFFF]"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#A7A7A7] text-[14px] md:text-[15px] leading-relaxed pr-6 pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
